import React, { useState, useEffect } from 'react';
import { append } from '../i18n/i18n';
import { storage } from '../../utils/storage';

const Locale = () => {
  const [language, setLanguage] = useState(() => storage.language.get());

  const changeLanguage = (lang) => {
    setLanguage(lang);
    storage.language.set(lang);
    append(require(`../../localization/${lang}.json`));
    window.location.reload();
  };

  useEffect(() => {
    storage.language.set(language);
    append(require(`../../localization/${language}.json`));
  }, [language]);

  return (
    <div className="locale-switcher">
      <button
        className={`locale-btn${language === 'ua' ? ' locale-btn--active' : ''}`}
        onClick={() => language !== 'ua' && changeLanguage('ua')}
        aria-label="Українська"
      >UA</button>
      <span className="locale-sep" aria-hidden="true">|</span>
      <button
        className={`locale-btn${language === 'en' ? ' locale-btn--active' : ''}`}
        onClick={() => language !== 'en' && changeLanguage('en')}
        aria-label="English"
      >EN</button>
    </div>
  );
};

export default Locale;
